export const START_ANIMATION_PROPERTY = {
  opacity: 0,
  transform: 'translateY(100px)',
};
export const END_ANIMATION_PROPERTY = {
  opacity: 1,
  transform: 'translateY(0px)',
};
export const VIEWPORT_PROPERTY = { once: true, amount: 0.3 };
